module.exports = __webpack_public_path__ + "static/media/audioFileIcon.6c832248.svg";